import React from 'react';
import ContactDrawer from 'ui/Drawer/ContactDrawer';
import Button from 'components/Button';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone.svg';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const PromotionText = ({ isWhiteBg }) => {
  PromotionText.propTypes = {
    isWhiteBg: PropTypes.bool.isRequired,
  };

  return (
    <p
      className={clsx('!text-sm !px-2 md:!px-0 lg:text-base', {
        'text-main': isWhiteBg,
      })}
    >
      Estimez le coût
      <br className="hidden smxl:block" />
      de votre projet !
    </p>
  );
};

const HellioLogo = ({ headerBgcolor, className }) => {
  HellioLogo.propTypes = {
    headerBgcolor: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
  };

  const logoSrc = clsx({
    '/logo-blue.svg': headerBgcolor === 'white',
    '/logo-white.svg': headerBgcolor !== 'white',
  });
  return <img src={logoSrc} className={clsx(className)} alt="Hellio logo" />;
};

const CustomHeader = ({
  logoMarque,
  logoLink,
  headerBgcolor,
  hideHellioLogo,
  homeLink,
}) => {
  CustomHeader.propTypes = {
    logoMarque: PropTypes.string.isRequired,
    logoLink: PropTypes.string,
    headerBgcolor: PropTypes.string.isRequired,
    hideHellioLogo: PropTypes.bool,
    homeLink: PropTypes.string.isRequired,
  };

  return (
    <div>
      {logoLink ? (
        <a href={logoLink} target="_blank" rel="noreferrer">
          <img src={logoMarque} className="logoMarque" />
        </a>
      ) : (
        <img src={logoMarque} className="logoMarque" />
      )}

      <PromotionText isWhiteBg={headerBgcolor === 'white'} />

      <a
        href={homeLink}
        target="_blank"
        rel="noreferrer"
        className={clsx('logoHeader', { 'is-hidden': hideHellioLogo })}
      >
        <HellioLogo headerBgcolor={headerBgcolor} />
      </a>
    </div>
  );
};

const DefaultHeader = ({ headerBgcolor, homeLink }) => {
  DefaultHeader.propTypes = {
    headerBgcolor: PropTypes.string.isRequired,
    homeLink: PropTypes.string.isRequired,
  };

  return (
    <div className="default-header">
      <div className="flex md:hidden">
        <ContactDrawer>
          <Button
            icon={<PhoneIcon className="text-bleu-hellio-600" />}
            className="!h-8 !w-8 !p-0 !bg-white !text-bleu-hellio-600"
          />
        </ContactDrawer>
      </div>

      <div className="flex flex-row items-center justify-center">
        <PromotionText isWhiteBg={false} />
      </div>

      <a
        href={homeLink}
        target="_blank"
        rel="noreferrer"
        className="logoHeader"
      >
        <HellioLogo headerBgcolor={headerBgcolor} />
      </a>

      <a
        href={homeLink}
        target="_blank"
        rel="noreferrer"
        className="only-show-tablette"
      >
        <HellioLogo
          headerBgcolor={headerBgcolor}
          className="logoHeaderDefault  !h-6"
        />
      </a>
    </div>
  );
};

const Header = ({
  logoMarque,
  logoLink,
  headerBgcolor,
  hideHellioLogo,
  homeLink,
}) => {
  return (
    <header className="header2">
      {logoMarque ? (
        <CustomHeader
          logoMarque={logoMarque}
          logoLink={logoLink}
          headerBgcolor={headerBgcolor}
          hideHellioLogo={hideHellioLogo}
          homeLink={homeLink}
        />
      ) : (
        <DefaultHeader headerBgcolor={headerBgcolor} homeLink={homeLink} />
      )}
    </header>
  );
};

Header.propTypes = {
  logoMarque: PropTypes.string,
  logoLink: PropTypes.string,
  headerBgcolor: PropTypes.string,
  hideHellioLogo: PropTypes.bool,
  homeLink: PropTypes.string,
};

export default Header;
